export default "__VITE_ASSET__CxnkB9LE__"